import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialGroupFinanceApi = {
    getTrialGroupFinanceByTrialGroupId: (trialGroupId: number): Observable<Dtos.GetTrialGroupFinanceByTrialGroupIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupFinanceByTrialGroupId = new Dtos.GetTrialGroupFinanceByTrialGroupId();
        request.trialGroupId = trialGroupId;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupFinanceByTrialGroupIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialGroupFinanceById: (id: number): Observable<Dtos.GetTrialGroupFinanceByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialGroupFinanceById = new Dtos.GetTrialGroupFinanceById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialGroupFinanceByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialGroupFinance: (trialGroupFinance: Dtos.TrialGroupFinance): Observable<Dtos.SetTrialGroupFinanceResponse> => {

        let request: Dtos.SetTrialGroupFinance = new Dtos.SetTrialGroupFinance();

        request.trialGroupFinance = trialGroupFinance;

        // send request
        const response: Promise<Dtos.SetTrialGroupFinanceResponse> = client.post(request);

        return Observable.from(response);
    },
    createTrialGroupFinance: (trialGroupId: number): Observable<Dtos.CreateTrialGroupFinanceResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialGroupFinance = new Dtos.CreateTrialGroupFinance();

        request.trialGroupId = trialGroupId;

        //Send request.
        const response: Promise<Dtos.CreateTrialGroupFinanceResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialGroupFinance: (trialGroupFinance: Dtos.TrialGroupFinance): Observable<Dtos.ValidateTrialGroupFinanceResponse> => {

        let request: Dtos.ValidateTrialGroupFinance = new Dtos.ValidateTrialGroupFinance();

        request.trialGroupFinance = trialGroupFinance;

        // send request
        const response: Promise<Dtos.ValidateTrialGroupFinanceResponse> = client.post(request);

        return Observable.from(response);
    },
}